import React, {useContext} from 'react';
import { AAMBeaconButton, AAMBeaconModal } from 'components/shared/Beacon';
import BeneficiaryContext from './BeneficiaryContext';

const BeneficiariesViewInvestmentsModal = () => {
    const { setViewInvestments, agreementsForBeneUpdate } = useContext(BeneficiaryContext);

    const handleCloseButton = () => {
        const modal = document.getElementById('beneficiaries_view_investments_modal');
        if (modal) {
            modal.close();
        }
    };

    const handleClose = () => {
        setViewInvestments(false);
    }

    const header = agreementsForBeneUpdate.length > 0 ? `${agreementsForBeneUpdate[0].accountType} Investments` : 'Investments';

    return (
        <AAMBeaconModal
            open={true}
            id="beneficiaries_view_investments_modal"
            className="beneficiaries_view_investments_modal"
            onBeaconEventClose={handleClose}>
            {<div className="b-grid beneficiaries_view_investments_modal_content">
                <h2 className="b-grid-item--12-col b-typography-sans-serif--headline--200 b-font-weight-bold">{header}</h2>
                {agreementsForBeneUpdate.map((agreement, index) => (
                    <div className="b-grid-item--12-col" key={index}>
                        <div className="b-typography-sans-serif--caption--200 b-font-weight-bold">{agreement.ticker}</div>
                        <div className="b-typography-sans-serif--body--200 b-font-weight-bold">{agreement.accountName}</div>
                        <div className="b-typography-sans-serif--caption--200 b-font-weight-light beneficiaries_view_investments_modal_account_number blocked_data">{agreement.accountNumber}-{agreement.accountChecksum}</div>
                    </div>
                ))}
            </div>}
            <div slot="action-zone" className="action-zone-align-right">
                <AAMBeaconButton
                    variant="primary"
                    scale="normal"
                    onBeaconEventClick={handleCloseButton}
                >
                    Close
                </AAMBeaconButton>
            </div>
        </AAMBeaconModal>
    );
};

export default BeneficiariesViewInvestmentsModal;
